export const Types = {
    CHECKITEMGROUPEXCEL_GET_EXCEL_LIST: "CHECKITEMGROUPEXCEL_GET_EXCEL_LIST",
    CHECKITEMGROUPEXCEL_SET_EXCEL_LIST: "CHECKITEMGROUPEXCEL_SET_EXCEL_LIST",
    CHECKITEMGROUPEXCEL_UPLOAD_FILE: "CHECKITEMGROUPEXCEL_UPLOAD_FILE",
    CHECKITEMGROUPEXCEL_EXCEL_FILE_OUTLINE: "CHECKITEMGROUPEXCEL_EXCEL_FILE_OUTLINE",
};

export const getExcelList = (payload) => ({
    type: Types.CHECKITEMGROUPEXCEL_GET_EXCEL_LIST,
    payload,
});

export const setExcelList = (payload) => ({
    type: Types.CHECKITEMGROUPEXCEL_SET_EXCEL_LIST,
    payload,
});

export const postExcelUpload = (payload) => ({
    type: Types.CHECKITEMGROUPEXCEL_UPLOAD_FILE,
    payload,
});

export const downloadExcelFile = (payload) => ({
    type: Types.CHECKITEMGROUPEXCEL_EXCEL_FILE_OUTLINE,
    payload,
});
